export { default } from './plain-card'
export type { Props as PlainCardProps } from './plain-card'
